import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/components/partials/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/components/partials/header/index.tsx");
